import { render, staticRenderFns } from "./WorkPacksContainer.vue?vue&type=template&id=354b096a&"
import script from "./WorkPacksContainer.vue?vue&type=script&lang=js&"
export * from "./WorkPacksContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('354b096a')) {
      api.createRecord('354b096a', component.options)
    } else {
      api.reload('354b096a', component.options)
    }
    module.hot.accept("./WorkPacksContainer.vue?vue&type=template&id=354b096a&", function () {
      api.rerender('354b096a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workPacks/components/WorkPacksContainer.vue"
export default component.exports